import { createRouter, createWebHashHistory } from 'vue-router'
import getHomeRoute from './home-routes'
import { isSecondaryAccount } from '@/utils/accountType'
// LIVE_MAP_ENABLED is no longer used -- Live Map's availability is now
// determined per-fleet instead of by a single global flag. Left commented
// out rather than removed in case a global kill-switch is needed again
// later.
// import { LIVE_MAP_ENABLED } from '@/config'

const getRoute = () => {
  return [
    getHomeRoute(),
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/Login'),
    },
  ]
}

const routes = getRoute()

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('user')
  if (authRequired && !loggedIn) {
    next('/login')
  } else if (to.meta.requiresPrimaryAccount && isSecondaryAccount()) {
    // next(LIVE_MAP_ENABLED ? '/live-map' : '/livestream')
    next('/live-map')
    // } else if (to.meta.requiresLiveMapEnabled && !LIVE_MAP_ENABLED) {
    //   next('/livestream')
  } else {
    next()
  }
})

export default router
